import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table"]

  copy(event) {
    const button = event.currentTarget
    const tableType = button.dataset.tableType
    const table = this.element.querySelector(`table[data-table="${tableType}"]`)
    
    if (!table) {
      this.showFeedback(button, "找不到表格")
      return
    }

    const dataText = this.extractDataFromTable(table)
    
    if (!dataText.trim()) {
      this.showFeedback(button, "無數據")
      return
    }
    
    // Copy to clipboard
    navigator.clipboard.writeText(dataText).then(() => {
      this.showFeedback(button, "已複製!")
    }).catch(() => {
      this.showFeedback(button, "複製失敗")
    })
  }

  extractDataFromTable(table) {
    const rows = table.querySelectorAll('tbody tr')
    const dataRows = []
    
    rows.forEach((row, rowIndex) => {
      // Skip header row (first row)
      if (rowIndex === 0) return
      
      const cells = row.querySelectorAll('td')
      const dataCells = []
      
      cells.forEach((cell, cellIndex) => {
        // Skip label column (first column)
        if (cellIndex === 0) return
        
        const span = cell.querySelector('span')
        const cellText = span ? span.textContent.trim() : cell.textContent.trim()
        dataCells.push(cellText)
      })
      
      if (dataCells.length > 0) {
        dataRows.push(dataCells.join('\t'))
      }
    })
    
    return dataRows.join('\n')
  }

  showFeedback(button, message) {
    const originalHTML = button.innerHTML
    button.innerHTML = message
    button.disabled = true
    
    setTimeout(() => {
      button.innerHTML = originalHTML
      button.disabled = false
    }, 1500)
  }
}